import { CheckCircle, LinkOutlined } from '@mui/icons-material';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Link,
  Switch,
  Typography,
} from '@mui/material';
import React from 'react';

const ShareDialog = ({
  onSharedUpdate,
  handleShareClosed,
  handleShareCopied,
  isOpen,
  shared,
  copySuccess,
}: {
  onSharedUpdate: (newValue: boolean) => void;
  handleShareClosed: () => void;
  handleShareCopied: () => void;
  isOpen: boolean;
  shared: boolean;
  copySuccess: boolean;
}) => {
  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleShareClosed}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Shared Link Settings</DialogTitle>
        <DialogContent style={{ display: 'flex', paddingTop: '10px' }}>
          <FormControlLabel
            control={
              <Switch
                checked={shared}
                onChange={(event) => {
                  onSharedUpdate(event.target.checked);
                }}
              />
            }
            label={`Shared Link ${shared ? 'On' : 'Off'}`}
          />
          {shared && (
            <>
              {copySuccess ? (
                <Typography
                  sx={{ color: 'green', display: 'flex', alignItems: 'center', gap: '5px' }}
                >
                  <CheckCircle sx={{ marginLeft: '5px' }} /> Link Copied to Clipboard
                </Typography>
              ) : (
                <Link
                  sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
                  onClick={handleShareCopied}
                >
                  <LinkOutlined /> Copy Link
                </Link>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ShareDialog;
